import React from 'react';
import { Router } from 'react-router-dom';
import { library } from '@fortawesome/fontawesome-svg-core'
import 'bootstrap/dist/css/bootstrap.min.css';
import './config/prototype.js';


import history from './config/history';
import Routes from './config/Routes';
import AppStorage from './config/AppStorage';
import Connection from './config/Connection';
import PageComponent from './components/PageComponent';
import ErrorComponent from './components/ErrorComponent';

import {
  faCreditCard, faHome, faTimes, faEdit, faUserCircle, faUser, faTimesCircle, faUsers, faCogs, faCog, faChartLine, faKey, faUserLock, faSignOutAlt, faPencilAlt,
  faList, faLanguage, faPlus, faMapMarkedAlt, faGlobeAmericas, faChessPawn, faChessKing, faChessRook, faUserPlus, faSuitcase, faBuilding, faStore, faPhone,
  faMapMarkerAlt, faEnvelope, faShoppingBag, faSeedling, faBoxOpen, faCubes, faCube, faTag, faTags, faInfoCircle, faSitemap, faIdCard, faTrophy, faCheckCircle, faClock, faUserClock, faBan,
  faQuestionCircle, faAward, faFile, faFileAlt, faDotCircle, faUndo, faPercentage, faChevronCircleLeft, faChevronCircleRight, faTrash, faAsterisk, faExclamationTriangle, faDollarSign, faMoneyBillWave, faTasks, faCity,
} from '@fortawesome/free-solid-svg-icons';
import { faSquare, faCheckSquare } from '@fortawesome/free-regular-svg-icons';
import CornLoader from './components/CornLoader';
import Labels from './Labels.js';
library.add(faTrophy, faIdCard, faSitemap, faInfoCircle, faCreditCard, faTag, faTags, faQuestionCircle, faDollarSign, faTasks,
  faCube, faCubes, faBoxOpen, faSeedling, faShoppingBag, faPhone, faCheckCircle, faClock, faFile, faFileAlt, faAsterisk, faCity,
  faEnvelope, faStore, faBuilding, faSuitcase, faUserPlus, faChessPawn, faUserClock, faDotCircle, faTrash, faExclamationTriangle,
  faChessRook, faChessKing, faMapMarkerAlt, faMapMarkedAlt, faGlobeAmericas, faBan, faUndo, faChevronCircleLeft, faChevronCircleRight,
  faKey, faPlus, faHome, faTimes, faEdit, faUserCircle, faUser, faTimesCircle, faUsers, faAward, faPercentage, faSquare, faCheckSquare,
  faCog, faCogs, faChartLine, faUserLock, faSignOutAlt, faPencilAlt, faList, faLanguage, faMoneyBillWave, faQuestionCircle);

global.app = null;
global.session = null;
global.token = null;
global.user = null;
global.permissions = null;
global.page = null;
global.applanguage = "";

export default class App extends PageComponent {

  constructor(props) {
    super(props);

    global.app = this;
    AppStorage.RestoreSession();
    var l = AppStorage.GetStorageKey("language");
    global.applanguage = Labels.toggleLanguage((l || navigator.language || navigator.userLanguage).split("-")[0]);
    this.state.error = null;
    this.state.loading = true;
  }

  
  componentWillMount() {
    fetch("/appsettings.json").then(response => {
      if (response.ok && response.status == 200)
        response.text().then(t => {
          try {
            window.AppSettings = JSON.parse(t);
          } catch (e) { }
          this.startApp();
        }).catch(t => this.setState({ error: response, loading: false }));
      else this.setState({ error: response, loading: false });
      // this.startApp();
    })
      .catch((error) => {
        // this.startApp();
        this.setState({ error: error != null ? error : true, loading: false });
      });
  }

  
  startApp() {
    if (global.token == null ? false : true)
      Connection.Secure(Connection.service + 'User/Information/')
        .then((response) => {
          if (response.ok && response.status == 200)
            response.json().then((data) => {
              global.user = data;
              this.processUserPermission(data)
              setTimeout(() => this.setState({ error: null, loading: false }));
            });
          else
            this.notLoggedIn(response);
        })
        .catch((error) => {
          if (error != null && typeof error === "object" && error.status == 401)
            this.notLoggedIn(error);
          else
            this.setState({ error: error != null ? error : true, loading: false });
        });
    else this.setState({ loading: false });
  }

  processUserPermission(target) {
    var permissions = {};
    if (typeof target === "object" && target != null && Array.isArray(target.personPermissionGroupMainPerson) && target.personPermissionGroupMainPerson.length > 0) {
      for (let i = 0; i < target.personPermissionGroupMainPerson.length; i++) {
        const element = target.personPermissionGroupMainPerson[i];
        if (typeof element === "object" && element != null && typeof element.logicalApGroups === "object" &&
          element.logicalApGroups != null && Array.isArray(element.logicalApGroups.appGroupPermissionElement))
          for (let j = 0; j < element.logicalApGroups.appGroupPermissionElement.length; j++) {
            const feature = element.logicalApGroups.appGroupPermissionElement[j];
            if (typeof feature === "object" && feature != null && typeof feature.logicalAppFeatures === "object" && typeof feature.logicalAppFeatures.keyFeature === "string")
              permissions[feature.logicalAppFeatures.keyFeature] = true;
          }
      }
    }
    else this.notLoggedIn();

    global.permissions = permissions;
  }

  notLoggedIn(data) {
    global.session = null;
    global.token = null;
    global.permissions = null;
    AppStorage.ClearStorageKey("session");
    AppStorage.ClearStorageKey("token");
    setTimeout(() =>
      window.location.reload()
      , 1);
    // this.setState({ error: data, loading: false })
  }

  render() {
    return (
      this.state.error != null ?
        <ErrorComponent error={this.state.error} /> :
        this.state.loading == true ?
          <CornLoader /> : <Router history={history} >
            <Routes />
          </Router>
    );
  }
} 
